<template lang="html">
  <div class="about">
    <div class="about-text">
      <div v-if="language  == 'en'">
      <!-- <p>The future project “Build on Volkswagen,” shows possibilities for the design of mobile spaces and associated business models. Users can adapt these to their personal needs (“customized”). The iconic “VW Bulli,” which its users have always helped to design (“co-creation”), serves as an inspiration.</p>
      <p>Volkswagen created an online configurator which visitors can use to create their own room. For this purpose over 80 virtual objects have been designed ranging from seating to interactive workstations as well as mobile 5G antennas which can be combined in thousands of possible configurations.</p>
      <p>All this is still at the very beginning stages, but the task is clear: How can we design mobile spaces that are created in dialogue with the user and adapted to their needs?</p> -->
      </div>
      <div v-else>
        <!-- <p>Das Zukunftsprojekt „Build on Volkswagen“ zeigt Möglichkeiten für die Gestaltung von mobilen Räumen und damit verbundene Businessmodelle. Diese können von Anwendern auf ihre persönlichen Bedürfnisse angepasst („customized“) werden. Als Inspiration steht der ikonenhafte „VW Bulli“, den seine Nutzer immer auch mitgestaltet haben („co-creation“). </p>
        <p>Volkswagen hat einen Onlinekonfigurator entwickelt mit dem sich Besucher ihren eigenen Raum zusammenstellen können. Dazu wurden über 80 virtuelle Objekte entworfen. Von Sitzgelegenheiten über interaktive Arbeitsplätze bis hin zu mobilen 5G-Antennen die in tausenden verschiedenen Konfigurationen zusammengestellt werden können.</p>
        <p>Das alles steht noch ganz am Anfang, aber der Auftrag ist klar: Wie können wir mobile Räume der Zukunft gestalten, die im Dialog mit dem Anwender entstehen und an seine Bedürfnisse angepasst sind?</p> -->
      </div>
    </div>
      <div class="about-footer">
        <ul class="about-footer-menu">
            <li>
              <a v-if="language == 'en'" href="/en/imprint">
                <span>Imprint</span>
              </a>
              <a v-if="language == 'de'" href="/de/imprint">
                <span>Impressum</span>
              </a>
            </li>
          <li>
            <a v-if="language == 'de'" href="/de/conditions-of-use">
              <span >Nutzungsbedingungen</span>
            </a>
            <a v-if="language == 'en'" href="/en/conditions-of-use">
              <span >Conditions of Use</span>
            </a>
          </li>
          <li>
            <a v-if="language == 'en'" href="/en/privacy-policy">
              <span >Data Protection Declaration</span>
            </a>
            <a v-if="language == 'de'" href="/de/privacy-policy">
              <span >Datenschutzerklärung</span>
            </a>
          </li>
          <li>
            <a v-if="language == 'en'" href="/en/cookie-policy">
              <span>Cookie Policy</span>
            </a>
            <a v-if="language == 'de'" href="/de/cookie-policy">
              <span>Cookie-Richtlinie</span>
            </a>
          </li>
        </ul>
        <div class="about-language_switcher">
          <a v-if="language == 'de'" @click="switchLanguage('en')">English</a>
          <a v-else  @click="switchLanguage('de')">Deutsch</a>
        </div>
      </div>
    </div>
  </template>

  <script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters(['language'])
    },
    methods:{
      switchLanguage(lang){
        this.$store.dispatch('setLanguage',lang);
      }
    }
  }
  </script>

  <style lang="scss">
    .about{
      position: fixed;
      bottom: -55px;
      width: 100%;
      padding: 4rem 3rem;
      height: 530px;
      background: #000000;
      color: white;
      &-text{
        width: 70%;
        p{
          color: white;
          margin-bottom: 20px;
          font-family:  'Union Regular',Helvetica, Arial, sans-serif;;
          font-weight:  normal;
          font-style:   normal;
          font-stretch: normal;
          font-size: 22px;
        }
      }
      &-footer{
        position: absolute;
        bottom: 80px;
        display:flex;
        justify-content: space-between;
        width: 94%;
        &-menu{
          margin-left: -15px;
          display: flex;
          justify-content: flex-start;
          li{
            margin: 0 15px;
            span{
              color: white;
              font-family:  'Union Regular', Helvetica, Arial, sans-serif;
              font-weight:  normal;
              font-style:   normal;
              font-stretch: normal;
            }
          }
        }
        .about-language_switcher{
          cursor: pointer;
          a{
            color: white !important;
            font-family:  'Union Regular', Helvetica, Arial, sans-serif;
            font-weight:  normal;
            font-style:   normal;
            font-stretch: normal;
          }
        }
      }
    }


    @media only screen and (max-width: 812px)  {
      .about{
        padding: 4rem 2rem;
      }
      .about-text{
        p{
          font-size: 19px;
        }
      }
      .about-footer{
        width: 88%;
      }
    }
    @media only screen and (max-width: 700px)  {
      .about{
        padding: 4rem 2rem;
        &-footer{
            align-items: flex-end;
        }
        &-footer-menu{
          flex-flow: column;
          li{
            margin: 5px 0;
          }
        }
      }
    }
  </style>
